.graph {
	width: 100%;
	height: 300px;
}
